.container {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
  width: 100%;
  padding: 0.5rem 0.1rem 0.5rem 0.2rem;
  overflow-y: scroll;
}

.legendItem {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  container-type: inline-size;
}

.circle {
  aspect-ratio: 1/1;
  flex-shrink: 0;
  width: 20%;
  border-radius: 50%;
  border: var(--color-border-accent) solid 1px;
}


.label {
  font-size: 13cqw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 4px;
}
